import { render, staticRenderFns } from "./SmsCampaignListItem.vue?vue&type=template&id=c94213e4"
import script from "./SmsCampaignListItem.vue?vue&type=script&lang=js"
export * from "./SmsCampaignListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports